export default () => throw new Promise(() => {});
